import { render, staticRenderFns } from "./FieldAltPhonemes.vue?vue&type=template&id=23103712&"
import script from "./FieldAltPhonemes.vue?vue&type=script&lang=ts&"
export * from "./FieldAltPhonemes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports